// #region IMPORT

import { useState } from 'react';

import { Box, Stack, Button, Container, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';

import { useResponsive } from 'src/hooks/use-responsive';

import { Carousel, useCarousel } from 'src/components/carousel';
import { APP_ICONS } from 'src/components/iconify/icon-constants';

import { CenterRegisterForm } from './center-register-form';
import { CarouselThumbCustom, CarouselThumbsCustom } from './carousel-thumbs-custom';
// #endregion

const TABS = [
  {
    title: 'Tuyển sinh',
    icon: APP_ICONS.communication.filterMailSquare,
  },
  {
    title: 'Tài chính',
    icon: APP_ICONS.finance.walletMoney,
  },
  {
    title: 'Học viên',
    icon: APP_ICONS.education.squareAcademicCap,
  },
  {
    title: 'Công việc & Lịch',
    icon: APP_ICONS.work.taskDaily,
  },
  {
    title: 'Nhân viên',
    icon: APP_ICONS.people.userGroup,
  },
  {
    title: 'Giáo viên',
    icon: APP_ICONS.education.questionSquare,
  },
  {
    title: 'Tổ chức lớp học',
    icon: APP_ICONS.education.notebook,
  },
  {
    title: 'Theo dõi buổi học',
    icon: APP_ICONS.education.notebook,
  },
  {
    title: 'Điểm danh',
    icon: APP_ICONS.people.scanUser,
  },
  {
    title: 'Học phí',
    icon: APP_ICONS.finance.money,
  },
  {
    title: 'Nghỉ học - Bảo lưu',
    icon: APP_ICONS.files.clipboardDocumentList,
  },
  // {
  //   title: 'Bài tập',
  //   icon: 'hugeicons:note-04',
  // },
];

export const HightlightFeatures = () => {
  const IMGS = [
    {
      id: '0',
      coverUrl: '/assets/sub-pages/manage/admission/admission-intro.png',
      title: 'Quản lý tuyển sinh với CenterUp',
      description:
        'Linh hoạt tùy chỉnh trạng thái khách hàng - Hẹn lịch và gửi thông báo tự động - Tích hợp đa kênh - Theo dõi tỉ lệ chuyển đổi - Quản lý hiệu suất nhân viên tư vấn tuyển sinh.',
      url: paths.subPage.manage.admission,
    },
    {
      id: '1',
      coverUrl: '/assets/sub-pages/manage/financial/intro.png',
      title: 'Quản lý tài chính với CenterUp',
      description:
        'Tự động lập báo cáo doanh thu & chi phí, báo cáo giao dịch, báo cáo dòng tiền, báo cáo quỹ theo thời gian thực - Luôn kiểm soát được thông tin tài chính, mọi lúc, mọi nơi.',
      url: paths.subPage.manage.financial,
    },
    {
      id: '2',
      coverUrl: '/assets/sub-pages/manage/student/intro.png',
      title: 'Quản lý học viên với CenterUp',
      description:
        'Quản lý hồ sơ học viên tập trung - Lịch sử lớp học - Báo cáo điểm danh - Báo cáo học tập - Báo cáo học phí & công nợ - Lịch sử tương tác và chăm sóc học viên.',
      url: paths.subPage.manage.student,
    },
    {
      id: '3',
      coverUrl: '/assets/sub-pages/manage/task/intro.png',
      title: 'Quản lý công việc với CenterUp',
      description:
        'Linh hoạt tùy chỉnh trạng thái công việc - Phân công cho từng nhân viên - Theo dõi theo từng học viên hoặc lớp học - Tự động nhắc việc - Đánh giá hiệu suất rõ ràng và minh bạch.',
      url: paths.subPage.manage.task,
    },
    {
      id: '4',
      coverUrl: '/assets/sub-pages/manage/hrm/intro.png',
      title: 'Quản lý nhân viên với CenterUp',
      description:
        'Hồ sơ nhân sự tập trung - Phân quyền chặt chẽ - Chấm công thông minh với công nghệ Faceid - Tính lương tự động - Lịch làm việc trực quan - Đánh giá hiệu suất rõ ràng & minh bạch.',
      url: paths.subPage.manage.hrm,
    },
    {
      id: '5',
      coverUrl: '/assets/sub-pages/lms/teacher-management/intro.png',
      title: 'Quản lý giáo viên với CenterUp',
      description:
        'Phân công giảng dạy - Lịch dạy trực quan - Chuyên cần & Nghỉ phép - Đánh giá dựa trên tiến độ giảng dạy và kết quả điểm số - Giao việc và đánh giá hiệu suất của từng giáo viên.',
      url: paths.subPage.lms.teacherManagement,
    },
    {
      id: '6',
      coverUrl: '/assets/sub-pages/operation/organize-class/intro.png',
      title: 'Tổ chức lớp học với CenterUp',
      description:
        'Thiết lập lịch học thông minh - Thời khóa biểu trực quan - Tự động gửi thông báo thay đổi - Phân công lịch dạy linh hoạt - Đồng bộ lịch dạy với bảng công và tính lương.',
      url: paths.subPage.operation.organizeClass,
    },
    {
      id: '7',
      coverUrl: '/assets/sub-pages/operation/session-tracking/intro.png',
      title: 'Theo dõi buổi học với CenterUp',
      description:
        'Theo dõi tiến độ lớp học - Nhật ký giảng dạy rõ ràng - Lưu trữ video buổi học - Nhận xét riêng tư cho học viên sau buổi học - Quản lý tài liệu và bài tập liên quan.',
      url: paths.subPage.operation.sessionTracking,
    },
    {
      id: '8',
      coverUrl: '/assets/sub-pages/operation/smart-attendance/intro.png',
      title: 'Điểm danh với CenterUp',
      description:
        'Điểm danh thông minh với công nghệ Faceid - Cảnh báo nghỉ học nhiều - Thông báo phụ huynh - Báo cáo điểm danh trực quan.',
      url: paths.subPage.operation.smartAttendance,
    },
    {
      id: '9',
      coverUrl: '/assets/sub-pages/operation/tuition-tracking/intro.png',
      title: 'Theo dõi học phí với CenterUp',
      description:
        'Linh hoạt thiết lập gói học phí và khuyến mãi - Theo dõi công nợ - Tự động nhắc phí - Tự động hạch toán phí theo thời gian học thực tế - Học sinh nộp học phí online dễ dàng.',
      url: paths.subPage.operation.tuitionTracking,
    },
    {
      id: '10',
      coverUrl: '/assets/sub-pages/operation/withdrawal/intro.png',
      title: 'Nghỉ học - Bảo lưu với CenterUp',
      description:
        'Tạo đơn và phê duyệt online dễ dàng - Theo dõi và xử lý đơn hoàn phí - Lưu log xử lý minh bạch - Chuyển phí toàn bộ hoặc một phần sang lớp khác, hoặc học viên khác. Hệ thống tự động tính số dư học phí.',
      url: paths.subPage.operation.withdrawal,
    },
  ];
  const smUp = useResponsive('up', 'sm');
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  const carousel = useCarousel({
    thumbs: {
      slidesToShow: 'auto',
    },
  });

  return (
    <Stack py={{ xs: 4, sm: 8, md: 15 }} id="hightlight-features">
      <Stack spacing={smUp ? 2 : 1}>
        <Container>
          <Stack spacing={smUp ? 2 : 1} alignItems="center">
            <Typography
              variant={smUp ? 'subtitle1' : 'body2'}
              fontFamily='"Shantell Sans Light", sans-serif'
              fontWeight="bold"
              color="primary.main"
            >
              Quản lý tất cả trong một nền tảng duy nhất
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h2" fontWeight="bold">
                Quản lý toàn diện
              </Typography>
            </Stack>{' '}
            <Typography
              textAlign="center"
              px={smUp ? 15 : 5}
              mt={2.5}
              mb={5}
              fontWeight="light"
              maxWidth={764}
            >
              100+ tính năng giúp Trung tâm tự động hóa tất cả hoạt động vận hành, tối ưu quy trình
              quản lý và tối đa hóa hiệu suất
            </Typography>
          </Stack>
        </Container>
        <Stack width={1} justifyContent="center" alignItems="center" overflow="hidden">
          <CarouselThumbsCustom
            ref={carousel.thumbs.thumbsRef}
            options={carousel.options?.thumbs}
            sx={{
              pt: 5,
              px: 2,
              pb: { xs: 3, md: 5 },
            }}
          >
            {TABS.map((item, index) => (
              <CarouselThumbCustom
                key={item.title}
                index={index}
                selected={index === carousel.thumbs.selectedIndex}
                onClick={() => carousel.thumbs.onClickThumb(index)}
                title={item.title}
                icon={item.icon}
                isSmUp={smUp}
                sx={{
                  width: smUp ? 180 : 160,
                  height: smUp ? 88 : 72,

                  '& > .MuiStack-root': {
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                    justifyContent: 'center',
                    px: smUp ? 2 : 1,
                    py: smUp ? 0.75 : 0.5,
                  },
                }}
              />
            ))}
          </CarouselThumbsCustom>

          <Container>
            <Carousel
              carousel={carousel}
              sx={{
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              {IMGS.map((item) => (
                <Stack
                  key={item.id}
                  direction={{
                    xs: 'column',
                    lg: 'row',
                  }}
                  alignItems="stretch"
                  sx={{
                    width: 1,
                    minHeight: {
                      xs: 680,
                      sm: 760,
                      md: 470,
                      lg: 500,
                    },
                    px: {
                      xs: 2,
                      sm: 4,
                      md: 5,
                      lg: 6,
                    },
                    py: {
                      xs: 3,
                      md: 4,
                    },
                  }}
                >
                  {/* Text */}
                  <Stack
                    alignItems="flex-start"
                    justifyContent="center"
                    sx={{
                      width: {
                        xs: 1,
                        lg: '40%',
                      },
                      maxWidth: {
                        xs: 'none',
                        lg: 500,
                      },
                      pr: {
                        lg: 4,
                      },
                      py: {
                        xs: 1,
                        lg: 3,
                      },
                    }}
                  >
                    <Typography
                      variant="h2"
                      sx={{
                        mb: 2.5,
                        width: 1,
                        maxWidth: {
                          xs: 'none',
                          lg: 460,
                        },
                        fontWeight: 700,
                        lineHeight: 1.15,
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2.5,
                        width: 1,
                        maxWidth: {
                          xs: 'none',
                          lg: 500,
                        },
                        fontWeight: 500,
                        lineHeight: 1.55,
                      }}
                    >
                      {item.description}
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        mb: { xs: 3, lg: 5 },
                        width: 1,
                        fontWeight: 600,
                      }}
                    >
                      “Tất cả trong một nền tảng duy nhất”
                    </Typography>

                    <Stack direction="row" flexWrap="wrap" gap={1}>
                      <Button size="large" href={item.url} variant="contained">
                        Xem chi tiết
                      </Button>

                      <Button
                        size="large"
                        color="primary"
                        variant="contained"
                        onClick={() => setOpenDemo(true)}
                      >
                        Đăng ký Demo
                      </Button>
                    </Stack>
                  </Stack>

                  {/* Image */}
                  <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      position: 'relative',
                      isolation: 'isolate',

                      width: {
                        xs: 1,
                        lg: '60%',
                      },
                      minHeight: {
                        xs: 320,
                        sm: 420,
                        md: 500,
                        lg: 450,
                      },
                      mt: {
                        xs: 3,
                        lg: 0,
                      },

                      overflow: 'visible',

                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        zIndex: 0,

                        width: {
                          xs: '85%',
                          sm: '78%',
                          md: '72%',
                        },
                        height: {
                          xs: '70%',
                          sm: '68%',
                          md: '65%',
                        },

                        left: {
                          xs: '4%',
                          sm: '7%',
                        },
                        top: {
                          xs: '18%',
                          sm: '15%',
                        },

                        borderRadius: '50%',
                        background: `
        radial-gradient(
          circle at 30% 35%,
          rgba(105, 92, 255, 0.28) 0%,
          rgba(153, 100, 255, 0.18) 32%,
          transparent 66%
        ),
        radial-gradient(
          circle at 72% 38%,
          rgba(255, 129, 204, 0.24) 0%,
          rgba(255, 178, 221, 0.14) 34%,
          transparent 68%
        ),
        radial-gradient(
          circle at 56% 78%,
          rgba(255, 221, 120, 0.22) 0%,
          transparent 64%
        )
      `,
                        filter: 'blur(34px)',
                        opacity: 0.95,
                        pointerEvents: 'none',
                      },

                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        zIndex: 0,

                        width: {
                          xs: '55%',
                          sm: '48%',
                        },
                        aspectRatio: '1',
                        right: {
                          xs: '-4%',
                          sm: '0%',
                        },
                        bottom: {
                          xs: '2%',
                          sm: '4%',
                        },

                        borderRadius: '50%',
                        background:
                          'radial-gradient(circle, rgba(126, 220, 255, 0.22) 0%, rgba(132, 155, 255, 0.12) 42%, transparent 72%)',
                        filter: 'blur(30px)',
                        pointerEvents: 'none',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      alt={item.title}
                      src={item.coverUrl}
                      sx={{
                        position: 'relative',
                        zIndex: 1,

                        display: 'block',
                        width: {
                          xs: '112%',
                          sm: '105%',
                          md: '100%',
                          lg: '110%',
                        },
                        maxWidth: 'none',
                        height: 'auto',
                        maxHeight: {
                          xs: 420,
                          sm: 520,
                          md: 560,
                          lg: 470,
                        },

                        objectFit: 'contain',
                        objectPosition: 'center',
                        userSelect: 'none',
                        pointerEvents: 'none',

                        filter: `
        drop-shadow(0 18px 28px rgba(77, 59, 163, 0.12))
        drop-shadow(0 5px 10px rgba(31, 38, 135, 0.08))
      `,
                      }}
                    />
                  </Stack>
                </Stack>
              ))}
            </Carousel>
          </Container>
        </Stack>
      </Stack>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Stack>
  );
};
